// ABOUTME: React Context for centralizing timezone handling across the app.
// ABOUTME: Eliminates prop drilling and provides consistent timezone utilities.

import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { getTodayInFamilyTimezone as getTodayUtil, getDateInFamilyTimezone as getDateUtil } from '../utils/dateUtils';

export interface TimezoneContextValue {
  familyTimezone: string | undefined;
  getTodayInFamilyTimezone: () => string;
  getDateInFamilyTimezone: (date: Date) => string;
}

const TimezoneContext = createContext<TimezoneContextValue | null>(null);

export interface TimezoneProviderProps {
  familyTimezone: string | undefined;
  children: ReactNode;
}

export const TimezoneProvider: React.FC<TimezoneProviderProps> = ({
  familyTimezone,
  children
}) => {
  const value = useMemo<TimezoneContextValue>(() => ({
    familyTimezone,
    getTodayInFamilyTimezone: () => getTodayUtil(familyTimezone),
    getDateInFamilyTimezone: (date: Date) => getDateUtil(date, familyTimezone),
  }), [familyTimezone]);

  return (
    <TimezoneContext.Provider value={value}>
      {children}
    </TimezoneContext.Provider>
  );
};

export const useTimezone = (): TimezoneContextValue => {
  const context = useContext(TimezoneContext);
  if (context === null) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
};

export default TimezoneContext;
